import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    listItemRoot: {
      paddingTop: theme.spacing(0.5),
      paddingBottom: theme.spacing(0.5),
    },
    listItemTextMultiline: { marginTop: '0px', marginBottom: '0px' },
    primaryText: {},
  };
};
